import React, { Component } from "react";
import { optionMasterService } from "app/_services/OptionMasterService/optionMasterService";
import toastr from "toastr";
import { IoIosArrowBack } from "react-icons/io";
import { Link } from "react-router-dom";
import { ProjectService } from "app/_services/ProjectService/ProjectService";
import { NotificationContainer, NotificationManager } from "react-notifications";
import {
  Dropdown,
  Row,
  Col,
  Tab,
  Tabs,
  Button,
  TabContent,
  Nav,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { FiPlusCircle, FiMinusCircle, FiCopy } from "react-icons/fi";
import { BlockService } from "app/_services/ConfigService/BlockService/BlockService";
import { Validation } from "app/_helpers/validation/Validation";
import { Constant } from "./Constant";
import { MasterService } from "app/_services/MasterService/MasterService";
import Prompt from "app/Components/IEnergyPrompt/Prompt";
import { formatDate, parseDate } from "react-day-picker/moment";
import DateTime from "react-datetime";
import DateTimePicker from "app/Components/DateTimeCustom/CustomDateTime";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
class AddBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      countryMasterId: "",
      stateMasterId: "",
      status: "",
      error: {},
      blockId: this.props.match.params.id ? this.props.match.params.id : "",
      // projectId: this.props.match.params.projectId ? this.props.match.params.projectId : "",
      // projectData: {},
      submitted: false,
      changeRoute: "",
      edit: false,
      e_p_regime: "",
      agreement_date: "",
      errorArray: [],
      projectLocation: [
        {
          lat_deg: null,
          lat_min: null,
          lat_sec: null,
          lat_dir: "",
          long_deg: null,
          long_min: null,
          long_sec: null,
          long_dir: "",
        },
        {
          lat_deg: null,
          lat_min: null,
          lat_sec: null,
          lat_dir: "",
          long_deg: null,
          long_min: null,
          long_sec: null,
          long_dir: "",
        },
        {
          lat_deg: null,
          lat_min: null,
          lat_sec: null,
          lat_dir: "",
          long_deg: null,
          long_min: null,
          long_sec: null,
          long_dir: "",
        },
      ],
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    // this.setProjectDetails();
    this.getCountryMaster(this.state.projectId);

    if (this.state.blockId) {
      this.setBlockData(this.state.blockId);
      this.setState({
        edit: true,
      });
    }
  }

  addLocation = (e) => {
    e.preventDefault();
    let formData = [
      ...this.state.projectLocation,
      {
        lat_deg: null,
        lat_min: null,
        lat_sec: null,
        lat_dir: "",
        long_deg: null,
        long_min: null,
        long_sec: null,
        long_dir: "",
      },
    ];
    this.setState({
      projectLocation: formData,
    });
  };

  removeLocationClick = (e, locationIndex) => {
    let projectLocation = [...this.state.projectLocation];
    projectLocation.splice(locationIndex, 1);
    this.setState({
      projectLocation: projectLocation,
    });
  };

  handleLatLongInputChange = (e, locationIndex) => {
    const { name, value } = e.target;
    var projectLocation = [...this.state.projectLocation];
    projectLocation[locationIndex][name] = value;
    this.setState({
      projectLocation: projectLocation,
    });
  };

  async getCountryMaster(projectId) {
    let response = await MasterService.getCountryByProjectID(projectId);
    if (response && response.status) {
      if (response.data && response.data) {
        this.setState({
          countryArr: response.data.countryMaster,
        });

        if (response.data.countryMaster && response.data.countryMaster.length === 1) {
          this.setState(
            {
              countryMasterId: response.data.countryMaster[0].id,
            },
            () => {
              this.getStateByCountryID(this.state.projectId, this.state.countryMasterId);
            }
          );
        }
      }
    }
  }

  async getStateByCountryID(projectId, countryMasterId) {
    let response = await MasterService.getStateByCountryID(projectId, countryMasterId);
    if (response && response.status) {
      if (response.data && response.data) {
        this.setState({
          stateArr: response.data.stateMaster,
        });

        if (response.data.stateMaster && response.data.stateMaster.length === 1) {
          this.setState(
            {
              stateMasterId: response.data.stateMaster[0].id,
            },
            () => {
              this.checkValidation();
            }
          );
        }
      }
    } else {
      this.unsetStateId();
    }
  }

  async setBlockData(blockId) {
    let response = await BlockService.getBlockByID(this.state.projectId, blockId);

    if (response && response.status) {
      if (response.data && response.data) {
        let blockData = response.data;
        this.setState(
          {
            blockData: blockData,
            name: blockData.name,
            status: blockData.activeStatus,
            countryMasterId: blockData.state_master.countryMasterId,
            stateMasterId: blockData.stateMasterId,
            e_p_regime: blockData.e_p_regime,
            agreement_date: blockData.agreement_date,
            projectLocation: blockData.project_locations,
          },
          () => {
            this.getStateByCountryID(this.state.projectId, this.state.countryMasterId);
          }
        );
      }
    } else {
      NotificationManager.info("No Record Found");
      this.props.history.push("/");
    }
  }

  // async setProjectDetails() {
  //     let response = await ProjectService.projectDetailsByID(this.state.projectId);

  //     if (response && response.status) {
  //         if (response.data && response.data) {
  //             this.setState({
  //                 projectData: response.data
  //             })
  //         }
  //     } else {
  //         toastr.info('No Record Found')
  //         this.props.history.push('/');
  //     }
  // }

  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState(
      {
        [name]: value,
      },
      () => {
        this.checkValidation();
      }
    );
  };

  onChangeStartDate = (day, index) => {
    var finaldate = "";

    if (day) {
      var date = new Date(day),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      finaldate = [date.getFullYear(), mnth, day].join("-");
    }
    this.setState(
      {
        agreement_date: finaldate,
      },
      () => {
        this.checkValidation();
      }
    );
  };

  /**********************Validation ***************/
  checkValidation() {
    this.setState({
      changeRoute: 1,
    });
    if (this.state.submitted) {
      var errobj = {};

      /**call validation file for validation */
      errobj = Validation(this.state, Constant.blockCustomField);

      this.setState({ error: errobj, submitted: true });
    }
  }

  async onSubmit(e) {
    e.preventDefault();

    var errobj = {};

    /**call validation file for validation */
    errobj = Validation(this.state, Constant.blockCustomField);

    this.setState({ error: errobj, submitted: true });
    /**
     * final checking for any error exists or not
     */
    var flag = 0;
    if (
      Array.isArray(this.state.projectLocation) &&
      this.state.projectLocation.length === 0
    ) {
      flag = 1;
      toastr.warning("Min one Sub Row is Required!");
    }
    const subActivity = rules;
    let sub_activity = this.state.projectLocation.slice();
    let subActivityErrorArray = [];
    sub_activity.map((value, index) => {
      var ActivityErrorObj = {};
      ActivityErrorObj = Validation(value, subActivity);
      subActivity.map((obj, index) => {
        let key = obj.field_name;
        if (ActivityErrorObj[key] !== "" && ActivityErrorObj[key] !== undefined) {
          flag = 1;
        }
      });
      subActivityErrorArray = subActivityErrorArray.concat(ActivityErrorObj);
    });

    this.setState({
      errorArray: subActivityErrorArray,
    });

    Object.keys(errobj).map((index) => {
      if (errobj[index] !== "") {
        flag = 1;
      }
    });

    if (flag === 0) {
      let obj = {
        name: this.state.name,
        activeStatus: this.state.status,
        stateMasterId: this.state.stateMasterId,
        // "project_id": this.state.projectId,
        e_p_regime: this.state.e_p_regime,
        agreement_date: this.state.agreement_date,
        projectLocation: this.state.projectLocation,
      };

      let data = {};

      if (this.state.edit) {
        data = await BlockService.updateBlock(
          this.state.projectId,
          this.state.blockId,
          obj
        );
      } else {
        data = await BlockService.createBlock(this.state.projectId, obj);
      }

      if (data && data.status === 1) {
        this.setState({
          changeRoute: "",
        });
        if (this.state.edit) {
          //NotificationManager.success('Block Updated')
          toastr.info("Block Updated");
          this.props.history.push("/global-configuration/project-details/block");
        } else {
          toastr.info("Block Created");
          //NotificationManager.success('Block Created')
          this.props.history.push("/global-configuration/project-details/block");
        }
      } else if (data && data.message) {
        toastr.warning(data.message);
        // NotificationManager.warning(data.message)
      }
    }
  }

  // Handle Form
  onSelectCountry = (e) => {
    if (e.target.value) {
      this.setCountryId(e.target.value);
    } else {
      this.unsetCountryId();
    }
  };
  setCountryId(id) {
    this.setState(
      {
        countryMasterId: id,
      },
      () => {
        this.getStateByCountryID(this.state.projectId, this.state.countryMasterId);
        this.checkValidation();
      }
    );
  }
  onSelectState = (e) => {
    if (e.target.value) {
      this.setStateId(e.target.value);
    } else {
      this.unsetStateId();
    }
  };
  setStateId(id) {
    this.setState(
      {
        stateMasterId: id,
      },
      () => {
        // this.getBlockByStateID(this.state.projectId, this.state.stateMasterId)
        this.checkValidation();
      }
    );
  }
  unsetCountryId() {
    this.setState(
      {
        countryMasterId: "",
        stateMasterId: "",
      },
      () => {
        this.checkValidation();
      }
    );
  }
  unsetStateId() {
    this.setState(
      {
        stateMasterId: "",
      },
      () => {
        this.checkValidation();
      }
    );
  }

  render() {
    const {
      name,
      status,
      projectData,
      projectId,
      edit,
      error,
      submitted,
      countryArr,
      stateArr,
      e_p_regime,
      countryMasterId,
      projectLocation,
    } = this.state;
    return (
      <div>
        <MainBreadcrumb
          routeSegments={[
            // { name: this.state.projectData.name, path: "/project/" + this.state.projectId + "/dashboard" },
            // { name: "Configuration", path: "#" },
            { name: "Global Settings", path: "#" },
            { name: "Block", path: "/global-configuration/project-details/block" },
            { name: edit ? "Edit" : "Add" },
          ]}
          // imageSrc={projectData && projectData.document && projectData.document.document_name ? projectData.document.document_name : ''}
          // description={projectData && projectData.descriptionDisplay ? projectData.descriptionDisplay : ''}
          breadCrumbsText="Configuration_Project_Details_Block"
        />
        <Prompt changes={this.state.changeRoute}></Prompt>
        <div className="row d-flex justify-content-center">
          <div className="col-md-12">
            <div className="card mt-4 mb-3">
              <div className="card-body">
                <div className="simple-card-title">
                  <h3 class="text-capitalize mb-1">{edit ? "Edit" : "Add"} Block</h3>
                </div>
                <form onSubmit={this.onSubmit}>
                  <div className="row">
                    <div className="col-md-4 form-group mb-3">
                      <label>Country</label>
                      {/* <select
                                                className="form-control customSelect"
                                                onChange={this.onSelectCountry}
                                                value={this.state.countryMasterId}
                                            >
                                                <option value=''>Select</option>
                                                {countryArr && countryArr.length > 0 ?
                                                    countryArr.map((data, index) => {
                                                        return <option
                                                            key={index}
                                                            value={data.id}
                                                        >{data.name}</option>
                                                    })
                                                    : ''
                                                }
                                            </select> */}

                      <SimpleSelect
                        className="form-control customSelect"
                        onChange={this.onSelectCountry}
                        value={this.state.countryMasterId}
                        id="id"
                        label="name"
                        options={countryArr}
                        init="Select"
                      ></SimpleSelect>

                      {submitted && error.countryMasterId !== "" && (
                        <div className="fromerror">{error.countryMasterId}</div>
                      )}
                    </div>
                    <div className="col-md-4 form-group mb-3">
                      <label>State</label>
                      {/* <select
                                                className="form-control customSelect"
                                                onChange={this.onSelectState}
                                                value={this.state.stateMasterId}
                                            >
                                                <option value=''>Select</option>
                                                {stateArr && stateArr.length > 0 ?
                                                    stateArr.map((data, index) => {
                                                        return <option
                                                            key={index}
                                                            value={data.id}
                                                        >{data.name}</option>
                                                    })
                                                    : ''
                                                }
                                            </select> */}

                      <SimpleSelect
                        className="form-control customSelect"
                        onChange={this.onSelectState}
                        value={this.state.stateMasterId}
                        id="id"
                        label="name"
                        options={stateArr}
                        init="Select"
                      ></SimpleSelect>

                      {submitted && error.stateMasterId !== "" && (
                        <div className="fromerror">{error.stateMasterId}</div>
                      )}
                    </div>
                    <div className="col-md-4 form-group mb-3">
                      <label>Block</label>
                      <input
                        name="name"
                        type="text"
                        className="form-control"
                        placeholder="Enter Block Name."
                        value={name}
                        onChange={(e) => this.handleInputChange(e)}
                      />
                      {submitted && error.name !== "" && (
                        <div className="fromerror">{error.name}</div>
                      )}
                    </div>
                    <div className="col-md-4 form-group mb-3">
                      <label>E&P Regime</label>
                      {/* <select
                                                className="form-control customSelect"
                                                value={e_p_regime}
                                                onChange={e => this.handleInputChange(e)}
                                                name="e_p_regime"
                                            >
                                                <option value=''>Select</option>
                                                <option value='Pre-NELP'>Pre-NELP</option>
                                                <option value='NELP'>NELP</option>
                                                <option value='HELP'>HELP</option>
                                                <option value='CBM'>CBM</option>
                                                <option value='OALP'>OALP</option>
                                                <option value='Others'>Others</option>
                                            </select> */}

                      <SimpleSelect
                        className="form-control customSelect"
                        value={e_p_regime}
                        onChange={(e) => this.handleInputChange(e)}
                        name="e_p_regime"
                        id="id"
                        label="name"
                        options={[
                          { id: "Pre-NELP", name: "Pre-NELP" },
                          { id: "NELP", name: "NELP" },
                          { id: "HELP", name: "HELP" },
                          { id: "CBM", name: "CBM" },
                          { id: "OALP", name: "OALP" },
                          { id: "Others", name: "Others" },
                        ]}
                        init="Select"
                      ></SimpleSelect>

                      {submitted && error.e_p_regime !== "" && (
                        <div className="fromerror">{error.e_p_regime}</div>
                      )}
                    </div>

                    <div className="col-md-4 form-group mb-3">
                      <label>Agreement Date</label>
                      <DateTimePicker
                        timeFormat={false}
                        placeholder="Status Date"
                        value={this.state.agreement_date}
                        dateFormat="YYYY-MM-DD"
                        formatDate={formatDate}
                        parseDate={parseDate}
                        inputProps={{ placeholder: "Select Date" }}
                        onChange={(day) => this.onChangeStartDate(day)}
                      />
                      {this.state.submitted &&
                        this.state.error &&
                        this.state.error.agreement_date !== "" && (
                          <div className="fromerror">
                            {this.state.error.agreement_date}
                          </div>
                        )}
                    </div>

                    <div className="col-md-4 form-group mb-3">
                      <label>Status</label>
                      {/* <select
                                                name="status"
                                                className="form-control"
                                                value={status}
                                                onChange={e => this.handleInputChange(e)}
                                            >
                                                <option value="">Select Status</option>
                                                <option value={1}>Active</option>
                                                <option value={2}>In-active</option>
                                            </select> */}

                      <SimpleSelect
                        name="status"
                        className="form-control"
                        value={status}
                        onChange={(e) => this.handleInputChange(e)}
                        id="id"
                        label="name"
                        options={[
                          { id: 1, name: "Active" },
                          { id: 2, name: "In-active" },
                        ]}
                        init="Select Status"
                      ></SimpleSelect>

                      {submitted && error.status !== "" && (
                        <div className="fromerror">{error.status}</div>
                      )}
                    </div>

                    <div className="col-md-12">
                      {/* <label>Latitude </label>
                                  <input type="text" className="form-control" placeholder="Enter Latitude" required /> */}
                      <div className="table-responsive latlongTable">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th scope="col">Coordinate</th>
                              <th scope="col" colSpan="4" style={{ textAlign: "center" }}>
                                Latitude
                              </th>
                              <th scope="col" colSpan="4" style={{ textAlign: "center" }}>
                                Longitude
                              </th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {projectLocation &&
                            Array.isArray(projectLocation) &&
                            projectLocation.length > 0
                              ? projectLocation.map((location, locationIndex) => {
                                  return (
                                    <tr key={locationIndex}>
                                      <th>{locationIndex + 1}</th>
                                      <td>
                                        <input
                                          name="lat_deg"
                                          type="text"
                                          min={0}
                                          className="form-control"
                                          placeholder="Degrees"
                                          value={location.lat_deg}
                                          onChange={(e) =>
                                            this.handleLatLongInputChange(
                                              e,
                                              locationIndex
                                            )
                                          }
                                        />
                                        {submitted &&
                                          this.state.errorArray[locationIndex] &&
                                          this.state.errorArray[locationIndex].lat_deg !==
                                            "" && (
                                            <div className="fromerror">
                                              {
                                                this.state.errorArray[locationIndex]
                                                  .lat_deg
                                              }
                                            </div>
                                          )}
                                      </td>
                                      <td>
                                        <input
                                          name="lat_min"
                                          type="text"
                                          min={0}
                                          className="form-control"
                                          placeholder="Minute"
                                          value={location.lat_min}
                                          onChange={(e) =>
                                            this.handleLatLongInputChange(
                                              e,
                                              locationIndex
                                            )
                                          }
                                        />
                                        {submitted &&
                                          this.state.errorArray[locationIndex] &&
                                          this.state.errorArray[locationIndex].lat_min !==
                                            "" && (
                                            <div className="fromerror">
                                              {
                                                this.state.errorArray[locationIndex]
                                                  .lat_min
                                              }
                                            </div>
                                          )}
                                      </td>
                                      <td>
                                        <input
                                          name="lat_sec"
                                          type="text"
                                          min={0}
                                          className="form-control"
                                          placeholder="Second"
                                          value={location.lat_sec}
                                          onChange={(e) =>
                                            this.handleLatLongInputChange(
                                              e,
                                              locationIndex
                                            )
                                          }
                                        />
                                        {submitted &&
                                          this.state.errorArray[locationIndex] &&
                                          this.state.errorArray[locationIndex].lat_sec !==
                                            "" && (
                                            <div className="fromerror">
                                              {
                                                this.state.errorArray[locationIndex]
                                                  .lat_sec
                                              }
                                            </div>
                                          )}
                                      </td>
                                      <td>
                                        {/* <select
                                                                                name="lat_dir"
                                                                                className="form-control"
                                                                                onChange={e => this.handleLatLongInputChange(e, locationIndex)}
                                                                                value={location.lat_dir}
                                                                            >
                                                                                <option value="">Direction</option>
                                                                                <option value="N">North</option>
                                                                                <option value="S">South</option>
                                                                                <option value="W">West</option>
                                                                                <option value="E">East</option>
                                                                            </select> */}

                                        <SimpleSelect
                                          name="lat_dir"
                                          className="form-control"
                                          onChange={(e) =>
                                            this.handleLatLongInputChange(
                                              e,
                                              locationIndex
                                            )
                                          }
                                          value={location.lat_dir}
                                          id="id"
                                          label="name"
                                          options={[
                                            { id: "N", name: "North" },
                                            { id: "S", name: "South" },
                                            { id: "W", name: "West" },
                                            { id: "E", name: "East" },
                                          ]}
                                          init="Direction"
                                        ></SimpleSelect>
                                        {submitted &&
                                          this.state.errorArray[locationIndex] &&
                                          this.state.errorArray[locationIndex].lat_dir !==
                                            "" && (
                                            <div className="fromerror">
                                              {
                                                this.state.errorArray[locationIndex]
                                                  .lat_dir
                                              }
                                            </div>
                                          )}
                                      </td>

                                      <td>
                                        <input
                                          name="long_deg"
                                          type="text"
                                          min={0}
                                          className="form-control"
                                          placeholder="Degrees"
                                          value={location.long_deg}
                                          onChange={(e) =>
                                            this.handleLatLongInputChange(
                                              e,
                                              locationIndex
                                            )
                                          }
                                        />
                                        {submitted &&
                                          this.state.errorArray[locationIndex] &&
                                          this.state.errorArray[locationIndex]
                                            .long_deg !== "" && (
                                            <div className="fromerror">
                                              {
                                                this.state.errorArray[locationIndex]
                                                  .long_deg
                                              }
                                            </div>
                                          )}
                                      </td>
                                      <td>
                                        <input
                                          name="long_min"
                                          type="text"
                                          min={0}
                                          className="form-control"
                                          placeholder="Minute"
                                          value={location.long_min}
                                          onChange={(e) =>
                                            this.handleLatLongInputChange(
                                              e,
                                              locationIndex
                                            )
                                          }
                                        />
                                        {submitted &&
                                          this.state.errorArray[locationIndex] &&
                                          this.state.errorArray[locationIndex]
                                            .long_min !== "" && (
                                            <div className="fromerror">
                                              {
                                                this.state.errorArray[locationIndex]
                                                  .long_min
                                              }
                                            </div>
                                          )}
                                      </td>
                                      <td>
                                        <input
                                          name="long_sec"
                                          type="text"
                                          min={0}
                                          className="form-control"
                                          placeholder="Second"
                                          value={location.long_sec}
                                          onChange={(e) =>
                                            this.handleLatLongInputChange(
                                              e,
                                              locationIndex
                                            )
                                          }
                                        />
                                        {submitted &&
                                          this.state.errorArray[locationIndex] &&
                                          this.state.errorArray[locationIndex]
                                            .long_sec !== "" && (
                                            <div className="fromerror">
                                              {
                                                this.state.errorArray[locationIndex]
                                                  .long_sec
                                              }
                                            </div>
                                          )}
                                      </td>
                                      <td>
                                        {/* <select
                                                                                name="long_dir"
                                                                                className="form-control"
                                                                                onChange={e => this.handleLatLongInputChange(e, locationIndex)}
                                                                                value={location.long_dir}
                                                                            >
                                                                                <option value="">Direction</option>
                                                                                <option value="N">North</option>
                                                                                <option value="S">South</option>
                                                                                <option value="W">West</option>
                                                                                <option value="E">East</option>
                                                                            </select> */}

                                        <SimpleSelect
                                          name="long_dir"
                                          className="form-control"
                                          onChange={(e) =>
                                            this.handleLatLongInputChange(
                                              e,
                                              locationIndex
                                            )
                                          }
                                          value={location.long_dir}
                                          id="id"
                                          label="name"
                                          options={[
                                            { id: "N", name: "North" },
                                            { id: "S", name: "South" },
                                            { id: "W", name: "West" },
                                            { id: "E", name: "East" },
                                          ]}
                                          init="Direction"
                                        ></SimpleSelect>
                                        {submitted &&
                                          this.state.errorArray[locationIndex] &&
                                          this.state.errorArray[locationIndex]
                                            .long_dir !== "" && (
                                            <div className="fromerror">
                                              {
                                                this.state.errorArray[locationIndex]
                                                  .long_dir
                                              }
                                            </div>
                                          )}
                                      </td>

                                      <td>
                                        <div className="actionIconsGroup">
                                          {this.state.projectLocation.length > 1 && (
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={
                                                <Tooltip id="tooltip-top">Delete</Tooltip>
                                              }
                                            >
                                              <a
                                                onClick={(e) =>
                                                  this.removeLocationClick(
                                                    e,
                                                    locationIndex
                                                  )
                                                }
                                                //  href="#"
                                                className="icons font-21 text-danger"
                                              >
                                                <FiMinusCircle />
                                              </a>
                                            </OverlayTrigger>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })
                              : ""}
                            <tr>
                              <td colSpan="10">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id="tooltip-top">Add Row</Tooltip>}
                                >
                                  <Button
                                    onClick={(e) => this.addLocation(e)}
                                    className="addRowPluseIcon ml-0"
                                  >
                                    <FiPlusCircle />
                                  </Button>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-md-12 mt-4 text-center">
                      <Link
                        to={"/global-configuration/project-details/block"}
                        className="btn btn-secondary mr-2"
                      >
                        Back
                      </Link>
                      <button className="btn btn-primary ml-2">
                        {edit ? "Update" : "Submit"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <NotificationContainer />
      </div>
    );
  }
}

export default AddBlock;

const rules = [
  {
    field_name: "lat_deg",
    label: "Degree",
    maxNumber: 90,
    minNumber: -90,
    type: "number",
    isRequired: true,
  },
  {
    field_name: "lat_min",
    label: "Minute",
    maxNumber: 60,
    type: "number",
    nonNegative: true,
    isRequired: true,
  },
  {
    field_name: "lat_sec",
    label: "Second",
    maxNumber: 60,
    type: "number",
    nonNegative: true,
    isRequired: true,
  },
  {
    field_name: "lat_dir",
    label: "Direction",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "long_deg",
    label: "Degree",
    maxNumber: 180,
    minNumber: -180,
    type: "number",
    isRequired: true,
  },
  {
    field_name: "long_min",
    label: "Minute",
    maxNumber: 60,
    type: "number",
    nonNegative: true,
    isRequired: true,
  },
  {
    field_name: "long_sec",
    label: "Second",
    maxNumber: 60,
    type: "number",
    nonNegative: true,
    isRequired: true,
  },
  {
    field_name: "long_dir",
    label: "Direction",
    type: "string",
    isRequired: true,
  },
];
